import { Link } from "@/i18n/navigation";
import { useAuth } from "@/shared/providers/AuthProvider";
import { SubscriptionTier } from "@/entities/billing/lib/billing.constants";

const PricingCardStarter = () => {
  const { user } = useAuth();
  return (
    <div
      className={
        "relative h-[612px] w-full rounded-lg border border-primary-dark px-[24px] pt-[24px] sm:w-[320px] sm:min-w-[320px] sm:pt-[28px]"
      }
    >
      <div>
        <div
          className={
            "flex h-[36px] w-[120px] items-center justify-center rounded-md bg-primary-dark text-title2 text-white"
          }
        >
          Starter
        </div>
        <div
          className={"mt-[6px] h-[40px] text-[10px] text-gray-400 sm:h-[56px]"}
        >
          Winging 기본 기능을 통해 셀프 AI 에이전트 도입에 적합한 요금제
        </div>
      </div>
      <div className={""}>
        <div className={"flex items-end justify-start"}>
          <div
            className={
              "text-[28px] font-[800] text-primary-dark sm:text-[30px]"
            }
          >
            ₩ 50,000원
          </div>
          <div
            className={
              "mb-[4px] ml-[8px] text-label2 font-[600] text-gray-400 sm:text-body2"
            }
          >
            / 월
          </div>
          <div
            className={
              "mb-[4px] ml-[4px] text-caption2 font-[600] text-gray-200"
            }
          >
            (VAT별도)
          </div>
        </div>
      </div>
      <div className={"mt-[32px]"}>
        <Link
          href={
            user?._id
              ? `/dashboard/billing/subscription?tier=${SubscriptionTier.Starter}`
              : "/auth/sign-in"
          }
          className={
            "flex h-[40px] w-full items-center justify-center rounded-md border border-primary-dark text-title2 text-primary-dark"
          }
        >
          시작하기
        </Link>
      </div>
      <div className={"mt-[52px] w-full"}>
        <div className={"w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary-dark"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#213F98"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600]"}>AI 에이전트 학습 및 배포</span>
          </div>
          <div
            className={
              "mt-[4px] flex w-full items-start justify-start gap-[11px] pl-[17px]"
            }
          >
            <svg
              className={"mt-[1px]"}
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1058_1953)">
                <path
                  d="M10.4991 4.37539L9.67661 3.49414L5.97828 7.45664L6.80078 8.33789L10.4991 4.37539ZM12.9724 3.49414L6.80078 10.1066L4.36245 7.50039L3.53995 8.38164L6.80078 11.8754L13.8008 4.37539L12.9724 3.49414ZM0.238281 8.38164L3.49911 11.8754L4.32161 10.9941L1.06661 7.50039L0.238281 8.38164Z"
                  fill="#686868"
                />
              </g>
              <defs>
                <clipPath id="clip0_1058_1953">
                  <rect width="14" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className={"text-label2 font-[600] text-gray-500"}>
              AI 에이전트 기본{" "}
              <span className={"font-[600] text-black"}>1개</span> 제공
              <ul className={"pl-[22px]"}>
                <li
                  className={"list-disc text-label2 font-[600] text-gray-500"}
                >
                  추가 시{" "}
                  <span className={"font-[600] text-black"}>
                    30,000원/월 (VAT 별도)
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary-dark"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#213F98"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600]"}>챗봇 에디터 제공</span>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "flex w-full items-center justify-start gap-[22px] text-primary-dark"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#213F98"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600]"}>AI 에이전트 메시지 발송</span>
          </div>
          <div
            className={
              "mt-[4px] flex w-full items-start justify-start gap-[11px] pl-[16px]"
            }
          >
            <svg
              className={"mt-[1px]"}
              width="14"
              height="15"
              viewBox="0 0 14 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_1058_1953)">
                <path
                  d="M10.4991 4.37539L9.67661 3.49414L5.97828 7.45664L6.80078 8.33789L10.4991 4.37539ZM12.9724 3.49414L6.80078 10.1066L4.36245 7.50039L3.53995 8.38164L6.80078 11.8754L13.8008 4.37539L12.9724 3.49414ZM0.238281 8.38164L3.49911 11.8754L4.32161 10.9941L1.06661 7.50039L0.238281 8.38164Z"
                  fill="#686868"
                />
              </g>
              <defs>
                <clipPath id="clip0_1058_1953">
                  <rect width="14" height="15" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className={"text-label2 font-[600] text-gray-500"}>
              AI 에이전트 메시지{" "}
              <span className={"font-[600] text-black"}>사용량 1,000건</span>
              <br />
              초과 사용 시{" "}
              <span className={"font-[600] text-black"}>
                9,000원 (300건 당)
              </span>
            </div>
          </div>
        </div>
        <div className={"mt-[18px] w-full"}>
          <div
            className={
              "relative flex w-fit items-center justify-start gap-[22px] text-primary-dark"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#C0C0C0"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-gray-200"}>데이터 튜닝</span>
            <div
              className={
                "absolute w-[calc(100%+8px)] border-t-[2px] border-t-gray-200"
              }
            ></div>
          </div>
        </div>
        <div className={"mt-[12px] w-full"}>
          <div
            className={
              "relative flex w-fit items-center justify-start gap-[22px] text-primary-dark"
            }
          >
            <svg
              width="19"
              height="14"
              viewBox="0 0 19 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 1.5L6.5 12.5L1.5 7.5"
                stroke="#C0C0C0"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={"font-[600] text-gray-200"}>
              실시간 상담사 채팅
            </span>
            <div
              className={
                "absolute w-[calc(100%+8px)] border-t-[2px] border-t-gray-200"
              }
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PricingCardStarter;
